<template>
    <v-container>
        <v-layout>
            <v-flex>
                <v-dialog  persistent v-model="dialog" max-width="550px">
                    <v-card>
                        <v-container>
                            <v-layout>
                                <v-flex xs12>
                                    <h1 class="text-xs-center primary--text">{{edit}}</h1>
                                </v-flex>
                            </v-layout>
                        <v-form>
                            <v-layout row wrap>
                            <v-flex xs12>
                            <v-text-field type="text" label="Party Name"
                                 v-model="partyName"
                                 ref="0"
                                 v-on:keyup.enter="gonext('2', $event)"
                                 ></v-text-field>
                            </v-flex>

                            <v-flex xs12>
                            <v-text-field type="text" label="Address"
                                 v-model="partyAddress"
                                 ref="0"
                                 v-on:keyup.enter="gonext('2', $event)"
                                 ></v-text-field>
                            </v-flex>

                            <v-flex xs12>
                            <v-text-field type="text" label="GSTIN"
                                 v-model="gstin"
                                 ref="0"
                                 v-on:keyup.enter="gonext('2', $event)"
                                 ></v-text-field>
                            </v-flex>

                            </v-layout>
                        </v-form>
                        </v-container>
                        <v-btn @click.stop="dialog=false">Close</v-btn>
                    </v-card>
                </v-dialog>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
export default {
    data () {
        return {
            partyName:null,
            partyAddress:null,
            gstin:null
        }
    },
    computed: {
        dialog: {
            get() {
                return this.$store.state.partyDialog
            },
            set(value) {
                this.$store.dispatch('partyDialog')
            }
        },
        edit: {
            get() {
                if(this.$store.state.partyMode == true) {
                    return 'Modify Party'
                } else {
                    return 'New Party Creation'
                }
            },
            set(value){

            }
        }
    }

}
</script>

<style>

</style>
